import Route from '@ember/routing/route'

export interface Params extends Record<string, unknown> {
  precinct?: string
  searchQuery?: string
  pageNumber: number
  perPage: number
}

export default class LessonsRoute extends Route {
  queryParams = {
    searchQuery: {
      replace: true,
      refreshModel: true,
    },
    precinct: {
      replace: true,
      refreshModel: true,
    },
    perPage: {
      replace: true,
      refreshModel: true,
    },
    pageNumber: {
      replace: true,
      refreshModel: true,
    },
  }
}

declare module '@ember/routing/route' {
  interface Registry {
    'subscription-type/lessons': LessonsRoute
  }
}
